/* eslint-disable filenames/match-exported -- Not worth the refactor. */
import account from './account';
import address from './address';
import affiliates from './affiliates';
import auth from './auth';
import avaTax from './services/avaTax';
import blog from './blog';
import breadcrumbs from './breadcrumbs';
import cards from './cards';
import carriers from './carriers';
import cart from './cart';
import checkout from './checkout';
import checkoutTimeout from './checkoutTimeout';
import content from './content';
import cookies from './cookies';
import ecommerce from './ecommerce';
import environment from './environment';
import featureFlagging from './featureFlagging';
import footer from './footer';
import giftCard from './giftCard';
import header from './header';
import help from './help';
import inventory from './inventory';
import locale from './locale';
import media from './media';
import menu from './menu';
import metadata from './metadata';
import navigation from './conductor/navigation';
import order from './order';
import personalization from './personalization';
import product from './product';
import productList from './productList';
import recommendations from './recommendations';
import returnAddress from './returnAddress';
import returns from './returns';
import reviews from './reviews';
import robots from './robots';
import routes from './routes';
import search from './search';
import session from './session';
import shippingMethods from './shippingMethods';
import sitemap from './sitemap';
import socials from './socials';
import states from './states';
import tagManagement from './tagManagement';
import test from './test';
import tracking from './tracking';
import ui from './ui';
import user from './user';
import pageError from './pageError';
import passwordPolicy from './passwordPolicy';
import promotions from './promotions';
// Integrations.
import applePay from './services/applePay';
import artlabs from './services/artlabs';
import aws from './services/aws';
import awsServices from './services/awsServices';
import attentive from './services/attentive';
import builderio from './services/builderio';
import cloudinary from './services/cloudinary';
import cognito from './services/cognito';
import coveo from './services/coveo';
import datadog from './services/datadog';
import doms from './services/doms';
import dynamicYield from './services/dynamicYield';
import easypost from './services/easypost';
import elasticPath from './services/elasticPath';
import forter from './services/forter';
import locally from './services/locally';
import magtek from './services/magtek';
import osano from './services/osano';
import otel from './services/otel';
import paypal from './services/paypal';
import pitneybowes from './services/pitneybowes';
import pixlee from './services/pixlee';
import safetech from './services/safetech';
import sfcc from './services/sfcc';
import sfccServices from './services/sfccServices';
import stylitics from './services/stylitics';
import talonOne from './services/talonOne';
import trueFit from './services/trueFit';
import ups from './services/ups';
import yotpo from './services/yotpo';
import powerReviews from './services/powerReviews';
import holiday from './services/holiday';
import gladly from './services/gladly';
import loqate from './services/loqate';

/** All known site configurations. */
const configs = {
  account,
  address,
  affiliates,
  applePay,
  artlabs,
  auth,
  avaTax,
  aws,
  awsServices,
  attentive,
  blog,
  breadcrumbs,
  builderio,
  cards,
  carriers,
  cart,
  checkout,
  checkoutTimeout,
  cloudinary,
  cognito,
  content,
  cookies,
  coveo,
  datadog,
  doms,
  dynamicYield,
  easypost,
  ecommerce,
  elasticPath,
  environment,
  featureFlagging,
  footer,
  forter,
  giftCard,
  gladly,
  header,
  help,
  holiday,
  inventory,
  locale,
  locally,
  loqate,
  magtek,
  media,
  menu,
  metadata,
  navigation,
  order,
  osano,
  otel,
  paypal,
  pageError,
  passwordPolicy,
  personalization,
  pitneybowes,
  pixlee,
  powerReviews,
  promotions,
  product,
  productList,
  recommendations,
  returnAddress,
  returns,
  reviews,
  robots,
  routes,
  safetech,
  search,
  session,
  sfcc,
  sfccServices,
  shippingMethods,
  sitemap,
  socials,
  states,
  stylitics,
  tagManagement,
  talonOne,
  test,
  tracking,
  trueFit,
  ui,
  ups,
  user,
  yotpo
};

export default configs;

/** Represents all config objects. */
export type Configs = typeof configs;

/** Represents a given config name for a known config object. */
export type ConfigName = keyof Configs;

export { csp } from './csp';
export { local, default as mocked } from './mocked';

export * from './types/ConfigSchema';
